import React from "react";
import PropTypes from "prop-types";
import purifyError from "./helpers/purifyError";

const Error = ({ error }) => {
  const err = purifyError({ ...error });

  if (
    typeof err === "object" &&
    !Array.isArray(err) &&
    err !== null &&
    err.hasOwnProperty("__html")
  ) {
    return (
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-absolute tw-inset-0">
        <div className="tw-flex-grow-333" />
        <div
          className="tw-w-3/4 tw-flex-grow tw-bg-red-300 tw-text-white tw-p-8 tw-text-center"
          data-testid="varsome-request-error"
          id="varsome-request-error"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={err}
        />
        <div className="tw-flex-grow-666" />
      </div>
    );
  }

  return null;
};

Error.propTypes = {
  error: PropTypes.shape({
    __html: PropTypes.string,
  }).isRequired,
};

export default Error;
